import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EventResponse } from "./types";
import { timezoneItems } from "../../close-part/features/EventBasicSettings/data";

export const getTzOffset = (tzName: string) => timezoneItems.find(tz => tz.value === tzName)?.data.offset || 0;


interface EventSlice {
  // We cannot use Moments in the state due to the error: "A non-serializable value was detected in the state"
  event: EventResponse | null;
  isSimpleEvent: boolean | null;
  eventTzOffset?: number;
}

const initialState: EventSlice = {
  event: null,
  isSimpleEvent: true, //todo set null when complex event will be ready
  eventTzOffset: undefined,
};

const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    setSimpleEvent(state, { payload }: PayloadAction<EventResponse>) {
      state.event = payload;
      state.eventTzOffset = getTzOffset(payload.tz);
    },
    setEventTzOffset(state, action: PayloadAction<number|string>) {
      state.eventTzOffset = typeof action.payload === "string"
        ? getTzOffset(action.payload)
        : action.payload;
    },
    clearEventState(state) {
      state.event = null;
      state.isSimpleEvent = true;
      state.eventTzOffset = undefined;
    },
    setIsSimpleEvent(state, action: PayloadAction<boolean>) {
      state.isSimpleEvent = action.payload;
    },
  }
});

export const {
  setSimpleEvent,
  clearEventState,
  setIsSimpleEvent,
  setEventTzOffset,
} = eventSlice.actions;


export default eventSlice.reducer;